import {BiDownload, BiExport, BiLoader} from 'react-icons/bi'
import {useContext, useMemo, useState} from 'react'
import {DataContext} from '../../context/DataContext'
import {FilterContext} from '../../context/FilterContext'
import {ExportSlide} from './ExportSlide'
import {default as legendaRenda} from '../../../../../img/legenda-renda.png'

import {formatNumber} from '../../../explorer/components/common'

import {Mapas} from './Mapas'
import LegendaIsocronas from './MapBox/LegendaIsocronas'
import {Dicionario} from '../../../../utils/Dicionario'
import {SlideSocioDemograficos} from './Slides/SocioDemografico'
import {SlideResumoMercado} from './Slides/ResumoMercado'
import secureLocalStorage from 'react-secure-storage'
import { SlidePerformance } from './Slides/Performance'

export function ExportarEstudo({id}: {id: number}) {
  const {data, cacheResult} = useContext(DataContext)
  const {endereco, dadosProjetoSalvo, filter} = useContext(FilterContext)
  const [mapImage, setMapImage] = useState({
    map1: null,
    map2: null,
    map3: null,
    concorrencia: [],
  })

  const [legendaDistancia, setLegendaDistancia] = useState(null)
  const [generateMap, setGenerateMap] = useState(false)
  const expectedConcorrenciaCount = useMemo(() => {
    let count = 0
    data?.forEach((item) => {
      item.tipologias?.forEach((tipologia) => {
        if (tipologia.comparar) {
          count += 1
        }
      })
    })
    return count
  }, [data])
  const isMapExportReady = useMemo(() => {
    if (!mapImage.map1 || !mapImage.map2) {
      return false
    }
    if (expectedConcorrenciaCount === 0) {
      return true
    }
    const concorrencia = Array.isArray(mapImage.concorrencia) ? mapImage.concorrencia : []
    if (concorrencia.length < expectedConcorrenciaCount) {
      return false
    }
    console.log('concorrencia')
    console.log(concorrencia.slice(0, expectedConcorrenciaCount).every(Boolean))
    return concorrencia.slice(0, expectedConcorrenciaCount).every(Boolean)
  }, [mapImage, expectedConcorrenciaCount])
  const handleExport = async () => {
    // const COLORS_SPECTRUM = [
    //   '56B4E4',
    //   '126CB0',
    //   '672C7E',
    //   'E92A31',
    //   'F06826',
    //   'E9AF1F',
    //   '51B747',
    //   '189247',
    // ]

    const logoEmpresa: any = secureLocalStorage.getItem('user_logo_empresa')
    const slide = new ExportSlide('IM', logoEmpresa)
    await slide.initMasterSlide()
    slide.filterAno = filter.anoLancamento
    slide.addCapa('Inteligência de Mercado', endereco.endereco_completo)

    //SLIDE -   Sociodemografico
    slide.addSlide('Sociodemográfico', (slideT) => {
      slideT.addImage({data: mapImage.map1, x: 0.6, y: 1.4, w: 6.8, h: 5.5})
      slideT.addImage({data: legendaDistancia, x: 0.7, y: 6.2, w: 0.9, h: 0.6})
      // slideT.addImage({data: legendaRenda, x: 0.7, y: 6.2, w: 0.9, h: 0.6})
      slideT.addImage({data: legendaRenda, x: 4.5, y: 6.2, w: 2.6, h: 0.6})

      const slideconfigTable1 = SlideSocioDemograficos(cacheResult, slideT)
      if (slideconfigTable1?.tableData?.length) {
        slide.addTable(slideconfigTable1)
      }
    })

    const removecolunas = [
      'id',
      'geom',
      'entretenimento',
      'bairro',
      'cep',
      'site',
      'areatotal',
      'areaconstruida',
      'areabruta',
      'telefone',
      'rua',
      'salascinema',
      'lojaancora',
    ]

    let count = 0.2
    let start = 1.3
    // // eslint-disable-next-line array-callback-return
    cacheResult.sociodemografico.map((item) => {
      if (item.tipo === 'qtde') {
        let tableData = []
        if (item.resultado?.itens.length > 0) {
          slide.addSlide('Sociodemográfico', (slideT) => {
            let tmp = []
            slide.addText(
              Dicionario.translate(item.resultado?.service) + ' em ' + item.distancia + 'metros',
              {
                x: 0.5,
                y: start,
                w: '100%',
                h: 0.6,
                align: 'left',
                fontSize: 24,
                textTransform: 'upper',
                color: '333',
                fontFace: 'Arial',
              },
              slideT
            )

            Object.entries(item.resultado?.itens[0]).map((col, index) => {
              if (removecolunas.indexOf(col[0]) === -1) {
                tmp.push({
                  text: Dicionario.translate(col[0]),
                  options: {color: '333333', align: 'left', bold: true},
                })
              }
            })

            tableData.push(tmp)
            item.resultado?.itens.map((item, index) => {
              let tmpData2 = []
              Object.entries(item).map((col, indexCol) => {
                if (removecolunas.indexOf(col[0]) === -1) {
                  tmpData2.push({
                    text: col[1],
                    options: {color: '333333', align: 'left', bold: false},
                  })
                }
              })
              tableData.push(tmpData2)
              return false
            })
            const slideconfigTable1 = {
              slide: slideT,
              tableData: tableData,
              config: {
                x: 0.5,
                y: start + 0.8,
                w: '92%',
                fill: {color: 'ffffff'},
                border: {pt: 0, color: 'e0e0e0'},
                fontSize: 10,
                autoPage: true,
                addHeaderToEach: true,
                colW: [3, 1.2, 2, 2, 3.5, 0.9],
              },
            }
            slide.addTable(slideconfigTable1)
            count = count + 0.2
          })
        }
      }
      //   // eslint-disable-next-line array-callback-return
      //   list ? (
      //     list.length > 0 ? (
      //       // eslint-disable-next-line array-callback-return
      //       Object.entries(list[0]).map((col, index) => {
      //         if (removecolunas.indexOf(col[0]) < -1) {
      //           return <th key={index}>{Dicionario.translate(col[0])}</th>
      //         }
      //       })
      //     ) : (
      //       <></>
      //     )
      //   ) : (
      //     <></>
      //   )
      // }
      //     let item = itemEntries[1]
      //     let valor = ''
      //     if (item['resultado']) {

      // tableData.push([
      //   {text: 'Estação', options: {color: '333333', align: 'left', bold: true}},
      //   {text: 'Linha', options: {color: '333333', align: 'center', bold: true}},
      //   {text: 'Situação', options: {color: '333333', align: 'center', bold: true}},
      //   {text: 'Tecnologia', options: {color: '333333', align: 'center', bold: true}},
      //   {text: 'Distancia', options: {color: '333333', align: 'center', bold: true}},
      // ])
      // tableData.push([
      //   {
      //     text: 'MARECHAL DEODORO',
      //     options: {color: '333333', align: 'left', bold: false},
      //   },
      //   {text: 'LINHA 3 - VERMELHA', options: {color: '333333', align: 'center', bold: false}},
      //   {text: 'Operando', options: {color: '333333', align: 'center', bold: false}},
      //   {text: 'Metro', options: {color: '333333', align: 'center', bold: false}},
      //   {text: '402', options: {color: '333333', align: 'center', bold: false}},
      // ])
    })

    //SLIDE -   Resumo Mercado
    slide.addSlide('Resumo Mercado', (slideT) => {
      slideT.addImage({data: mapImage.map2, x: 0.6, y: 1.4, w: 7, h: 5.5})
      slideT.addImage({data: legendaDistancia, x: 0.7, y: 6.2, w: 0.9, h: 0.6})
      const slideconfigTable1 = SlideResumoMercado(data, slideT)
      slide.addTable(slideconfigTable1)
    })
    const comparaveisAll = []

    data?.forEach((item) => {
      if (item.computed && Array.isArray(item.tipologias)) {
        item.tipologias.forEach((tipologia) => {
          // if (cacheResult.comparaveis?.includes(tipologia.id_tipologia)) {
          if (tipologia.comparar) {
            const areaUtil = tipologia.private_area || 0
            const precoM2 = areaUtil ? tipologia.original_price / areaUtil : 0
            comparaveisAll.push({
              id_tipologia: tipologia.id_tipologia,
              comparar: tipologia.comparar === true,
              nome: item.nome,
              incorporadora: item.nome_incorporador,
              tipologia: tipologia.bedrooms,
              area_util: areaUtil,
              unidades: tipologia.total_units,
              vendidas: tipologia.total_units - tipologia.stock,
              estoque: tipologia.stock,
              preco_m2: precoM2,
            })
          }
          // }
        })
      }
    })

    //SLIDE -   ANALISE CONCORRENCIA
    // slide.addSlide('ANÁLISE CONCORRÊNCIA', (slideT) => {
    //   slide.addText(
    //     'ANÁLISE CONCORRÊNCIA',
    //     {
    //       x: 0.5,
    //       y: start,
    //       w: '100%',
    //       h: 0.6,
    //       align: 'left',
    //       fontSize: 24,
    //       textTransform: 'upper',
    //       color: '333',
    //       fontFace: 'Arial',
    //     },
    //     slideT
    //   )

    //   if (mapImage.map1) {
    //     slideT.addImage({data: mapImage.map1, x: 0.5, y: 1.9, w: 6, h: 4})
    //   }

    //   const comparaveis = comparaveisAll
    //   const incorporadorasDestaque = Array.from(
    //     new Set(comparaveis.map((row) => row.incorporadora).filter(Boolean))
    //   )
    //   const destaqueTexto = incorporadorasDestaque.length
    //     ? `Destacar: ${incorporadorasDestaque.join(', ')}`
    //     : 'Destacar: -'

    //   slide.addText(
    //     destaqueTexto,
    //     {
    //       x: 6.6,
    //       y: 1.6,
    //       w: 5.4,
    //       h: 0.4,
    //       align: 'left',
    //       fontSize: 12,
    //       color: '333333',
    //       fontFace: 'Arial',
    //     },
    //     slideT
    //   )

    //   slide.addText(
    //     `Qtde. Comparaveis: (${comparaveis.length})`,
    //     {
    //       x: 6.6,
    //       y: 2.1,
    //       w: 3.2,
    //       h: 0.4,
    //       align: 'left',
    //       fontSize: 11,
    //       color: '333333',
    //       fontFace: 'Arial',
    //       fill: {color: 'EFEFEF'},
    //     },
    //     slideT
    //   )

    //   const tableData = []
    //   tableData.push([
    //     'Nome',
    //     'Incorporadora',
    //     'Tipologia',
    //     'Area Util',
    //     'Unidades Lancadas',
    //     'Unidades Vendidas',
    //     'Estoque',
    //     'Preco m2',
    //   ])
    //   comparaveis.forEach((row) => {
    //     tableData.push([
    //       row.nome,
    //       row.incorporadora,
    //       row.tipologia,
    //       formatNumber(row.area_util, 'decimal'),
    //       row.unidades,
    //       row.vendidas,
    //       row.estoque,
    //       formatNumber(row.preco_m2, 'currency_inteiro'),
    //     ])
    //   })
    //   slideT.addTable(tableData, {
    //     x: 6.6,
    //     y: 2.7,
    //     w: 5.4,
    //     colW: [2.2, 1.6, 0.7, 0.9, 0.9, 0.9, 0.7, 0.9],
    //     fontSize: 9,
    //     color: '333333',
    //     border: {type: 'solid', pt: 1, color: 'd0d0d0'},
    //   })
    // })

    comparaveisAll.forEach((row, index) => {
      slide.addSlide('ANALISE CONCORRENCIA', (slideT) => {
        slide.addText(
          'ANALISE CONCORRENCIA',
          {
            x: 0.5,
            y: 1.5,
            w: '100%',
            h: 0.4,
            align: 'left',
            fontSize: 22,
            textTransform: 'upper',
            color: '333',
            fontFace: 'Arial',
          },
          slideT
        )

        const detalheRows = [
          ['Nome', row.nome],
          ['Incorporadora', row.incorporadora],
          ['Tipologia', String(row.tipologia)],
          ['Area Util', formatNumber(row.area_util, 'decimal')],
          ['Unidades Lancadas', String(row.unidades)],
          ['Unidades Vendidas', String(row.vendidas)],
          ['Estoque', String(row.estoque)],
          ['Preco m2', formatNumber(row.preco_m2, 'currency_inteiro')],
        ]
        const detalheTable = detalheRows.map((item, rowIndex) => [
          {
            text: item[0],
            options: {
              bold: true,
              fill: {color: rowIndex % 2 === 0 ? 'F2F2F2' : 'FFFFFF'},
            },
          },
          {
            text: item[1],
            options: {fill: {color: rowIndex % 2 === 0 ? 'F2F2F2' : 'FFFFFF'}},
          },
        ])

        slideT.addTable(detalheTable, {
          x: 0.5,
          y: 2.1,
          w: 5.8,
          colW: [2.2, 3.6],
          fontSize: 10,
          color: '333333',
          border: {type: 'solid', pt: 1, color: 'd0d0d0'},
        })

        const concorrenciaImage = mapImage?.concorrencia?.[index]
        if (concorrenciaImage) {
          slideT.addImage({data: concorrenciaImage, x: 6.6, y: 2.1, w: 6.6, h: 4.6})
        }
      })
    })

    slide.addSlide('Performance', (slideT) => {
      //Linha 1
      slide.addBox({
        slide: slideT,
        titulo: 'PREÇO MÉDIO M² ESTOQUE',
        subtitulo: 'Valor do preço médio do m² do estoque',
        valor: formatNumber(Math.round(cacheResult.performance.precoMedioM2Estoque), 'currency'),
        config: {
          x: 0.4,
          y: 1.2,
          w: 3.3,
          h: 1.3,
          margin: 15,
          fill: {color: 'ffffff'},
          borderColor: '333333',
          borderTopLeftRadius: 5,
          lineSpacingMultiple: 1.5,
        },
      })
      slide.addBox({
        slide: slideT,
        titulo: 'VGV LANÇADO',
        subtitulo: 'Total do VGV lançado',
        valor: formatNumber(Math.round(cacheResult.performance.vgvLancado), 'currency'),
        config: {
          x: 3.8,
          y: 1.2,
          w: 3.2,
          h: 1.3,
          margin: 15,
          fill: {color: 'ffffff'},
          borderColor: '333333',
          borderTopLeftRadius: 5,
          lineSpacingMultiple: 1.5,
        },
      })
  
      //Linha 2
      slide.addBox({
        slide: slideT,
        titulo: 'VGV VENDIDO',
        subtitulo: 'Total do VGV Vendido',
        valor: formatNumber(Math.round(cacheResult.performance.vgvVendido), 'currency'),
        config: {
          x: 0.4,
          y: 2.5,
          w: 3.3,
          h: 1.3,
          margin: 15,
          fill: {color: 'ffffff'},
          borderColor: '333333',
          borderTopLeftRadius: 5,
          lineSpacingMultiple: 1.5,
        },
      })
  
      slide.addBox({
        slide: slideT,
        titulo: 'VGV ESTOQUE',
        subtitulo: 'Total do VGV do estoque',
        valor: formatNumber(Math.round(cacheResult.performance.vgvEstoque), 'currency'),
        config: {
          x: 3.8,
          y: 2.5,
          w: 3.3,
          h: 1.3,
          margin: 15,
          fill: {color: 'ffffff'},
          borderColor: '333333',
          borderTopLeftRadius: 5,
          lineSpacingMultiple: 1.5,
        },
      })
  
      //Linha 3
      slide.addBox({
        slide: slideT,
        titulo: 'PRODUTOS LANÇADOS',
        subtitulo: 'Total de Produtos Lançados',
        valor: cacheResult.performance.totalProdutosLancados,
        config: {
          x: 0.4,
          y: 3.9,
          w: 3.3,
          h: 1.3,
          margin: 15,
          fill: {color: 'ffffff'},
          borderColor: '333333',
          borderTopLeftRadius: 5,
          lineSpacingMultiple: 1.5,
        },
      })
  
      slide.addBox({
        slide: slideT,
        titulo: 'UNIDADES LANÇADAS',
        subtitulo: 'Total de unidades lançadas',
        valor: cacheResult.performance.unidadesLancadas,
        config: {
          x: 3.8,
          y: 3.9,
          w: 3.2,
          h: 1.3,
          margin: 15,
          fill: {color: 'ffffff'},
          borderColor: '333333',
          borderTopLeftRadius: 5,
          lineSpacingMultiple: 1.5,
        },
      })
  
      //Linha 4
  
      slide.addBox({
        slide: slideT,
        titulo: 'UNIDADES VENDIDAS',
        subtitulo: 'Total de unidades vendidas',
        valor: cacheResult.performance.unidadesVendidas,
        config: {
          x: 0.4,
          y: 5.2,
          w: 3.2,
          h: 1.3,
          margin: 15,
          fill: {color: 'ffffff'},
          borderColor: '333333',
          borderTopLeftRadius: 5,
          lineSpacingMultiple: 1.5,
        },
      })
  
      slide.addBox({
        slide: slideT,
        titulo: 'ESTOQUE',
        subtitulo: 'Total de unidades em estoque',
        valor: cacheResult.performance.estoque,
        config: {
          x: 3.8,
          y: 5.2,
          w: 3.2,
          h: 1.3,
          margin: 15,
          fill: {color: 'ffffff'},
          borderColor: '333333',
          borderTopLeftRadius: 5,
          lineSpacingMultiple: 1.5,
        },
      })
  
      let listaEmpLancados = []
      let listaUnidadesLancados = []
      listaEmpLancados.push([
        {text: 'Ano', options: {color: '333333', align: 'left', bold: true}},
        {text: 'Qtde', options: {color: '333333', align: 'center', bold: true}},
      ])
      // eslint-disable-next-line array-callback-return
      Object.entries(cacheResult.performance.lancamentosPorAno).map((item, index) => {
        listaEmpLancados.push([
          {
            text: item[0],
            options: {color: '333333', align: 'left', bold: true},
          },
          {text: item[1], options: {color: '333333', align: 'center', bold: false}},
        ])
      })
  
      listaUnidadesLancados.push([
        {text: 'Ano', options: {color: '333333', align: 'left', bold: true}},
        {text: 'Qtde', options: {color: '333333', align: 'center', bold: true}},
      ])
      // eslint-disable-next-line array-callback-return
      Object.entries(cacheResult.performance.unidadesLancadasPorAno).map((item, index) => {
        listaUnidadesLancados.push([
          {
            text: item[0],
            options: {color: '333333', align: 'left', bold: true},
          },
          {text: item[1], options: {color: '333333', align: 'center', bold: false}},
        ])
      })
  
      //Linha 3
      slide.addBoxList({
        slide: slideT,
        titulo: 'LANÇAMENTOS POR ANO',
        subtitulo: 'Total de empreendimentos lançados',
        valor: '7',
        lista: listaEmpLancados,
        config: {
          x: 7.1,
          y: 1.2,
          w: 3.2,
          h: 1.2,
          fill: {color: 'ffffff'},
        },
      })
  
      //Linha 3
      slide.addBoxList({
        slide: slideT,
        titulo: 'UNIDADES LANÇADAS POR ANO',
        subtitulo: 'Total de unidades lançadas',
        valor: '7',
        lista: listaUnidadesLancados,
        config: {
          x: 10,
          y: 1.2,
          w: 3.2,
          h: 1.2,
          fill: {color: 'ffffff'},
        },
      })
    })

    //SLIDE -   Performance -   1
    slide.addSlide('Performance - Resumo Mercado ', (slideT) => {
      //COL1 Preço médio estoque

      //Preço Médio de Lançamento - R$/m²
      slide.addText(
        'Preço Médio de Lançamento - R$/m²',
        {
          x: 0.5,
          y: 1.6,
          w: 6.0,
          align: 'left',
          fontSize: 24,
          textTransform: 'upper',
          color: '333',
          fontFace: 'Arial',
        },
        slideT
      )
      let tableData01 = []

      tableData01.push([
        {text: 'Dormitórios', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Mínimo', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Mediana', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Máximo', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Total Unidades', options: {color: '333333', align: 'center', bold: true}},
        // {text: 'Vendidas', options: {color: '333333', align: 'center', bold: true}},
        // {text: 'Estoque', options: {color: '333333', align: 'center', bold: true}},
      ])
      // eslint-disable-next-line array-callback-return
      cacheResult.performanceResumoMercado.precoMedioLancamentoM2.tableData.map((item) => {
        if (!Array.isArray(item)) {
          tableData01.push([
            {text: item.dormitorios, options: {color: '333333', align: 'center'}},
            {
              text: formatNumber(Math.round(item.min), 'currency'),
              options: {color: '333333', align: 'center', bold: false},
            },
            {
              text: formatNumber(Math.round(item.mediana), 'currency'),
              options: {color: '333333', align: 'center', bold: false},
            },
            {
              text: formatNumber(Math.round(item.max), 'currency'),
              options: {color: '333333', align: 'center', bold: false},
            },
            {text: item.total_unidades, options: {color: '333333', align: 'center', bold: false}},
            // {text: item.vendas, options: {color: '333333', align: 'center', bold: false}},
            // {text: item.estoque, options: {color: '333333', align: 'center', bold: false}},
          ])
        }
      })

      const slideconfigTable01 = {
        slide: slideT,
        tableData: tableData01,
        config: {
          x: 0.5,
          y: 2,
          w: 6.0,
          margin: 3,
          fontSize: 10,
          fill: {color: 'ffffff'},
          border: {pt: 1, color: 'd0d0d0'},
        },
      }

      slide.addTable(slideconfigTable01)

      //Preço Médio em Estoque - R$/m²
      slide.addText(
        'Preço Médio em Estoque - R$/m²',
        {
          x: 7.0,
          y: 1.6,
          w: 6.0,
          align: 'left',
          fontSize: 24,
          textTransform: 'upper',
          color: '333',
          fontFace: 'Arial',
        },
        slideT
      )

      let tableData02 = []

      tableData02.push([
        {text: 'Dormitórios', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Mínimo', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Mediana', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Máximo', options: {color: '333333', align: 'center', bold: true}},
        // {text: 'Total Unidades', options: {color: '333333', align: 'center', bold: true}},
        // {text: 'Vendidas', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Estoque', options: {color: '333333', align: 'center', bold: true}},
      ])
      // eslint-disable-next-line array-callback-return
      cacheResult.performanceResumoMercado.precoMedioEstoqueRM2.tableData.map((item) => {
        if (!Array.isArray(item)) {
          tableData02.push([
            {text: item.dormitorios, options: {color: '333333', align: 'center'}},
            {
              text: formatNumber(Math.round(item.min), 'currency'),
              options: {color: '333333', align: 'center', bold: false},
            },
            {
              text: formatNumber(Math.round(item.mediana), 'currency'),
              options: {color: '333333', align: 'center', bold: false},
            },
            {
              text: formatNumber(Math.round(item.max), 'currency'),
              options: {color: '333333', align: 'center', bold: false},
            },
            // {text: item.total_unidades, options: {color: '333333', align: 'center', bold: false}},
            // {text: item.vendas, options: {color: '333333', align: 'center', bold: false}},
            {text: item.estoque, options: {color: '333333', align: 'center', bold: false}},
          ])
        }
      })

      const slideconfigTable02 = {
        slide: slideT,
        tableData: tableData02,
        config: {
          x: 7.0,
          y: 2,
          w: 6.0,
          margin: 3,
          fontSize: 10,
          fill: {color: 'ffffff'},
          border: {pt: 1, color: 'd0d0d0'},
        },
      }

      slide.addTable(slideconfigTable02)

      //Ticket Médio de Lançamento - R$
      slide.addText(
        'Ticket Médio de Lançamento - R$',
        {
          x: 0.5,
          y: 4,
          w: 6,
          align: 'left',
          fontSize: 24,
          textTransform: 'upper',
          color: '333',
          fontFace: 'Arial',
        },
        slideT
      )

      let tableData03 = []
      tableData03.push([
        {text: 'Dormitórios', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Mínimo', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Mediana', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Máximo', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Total Unidades', options: {color: '333333', align: 'center', bold: true}},
        // {text: 'Vendidas', options: {color: '333333', align: 'center', bold: true}},
        // {text: 'Estoque', options: {color: '333333', align: 'center', bold: true}},
      ])
      // eslint-disable-next-line array-callback-return
      cacheResult.performanceResumoMercado.ticketMedioLancamentoEstoque.tableData.map((item) => {
        if (!Array.isArray(item)) {
          tableData03.push([
            {text: item.dormitorios, options: {color: '333333', align: 'center'}},
            {
              text: formatNumber(Math.round(item.min), 'currency'),
              options: {color: '333333', align: 'center', bold: false},
            },
            {
              text: formatNumber(Math.round(item.mediana), 'currency'),
              options: {color: '333333', align: 'center', bold: false},
            },
            {
              text: formatNumber(Math.round(item.max), 'currency'),
              options: {color: '333333', align: 'center', bold: false},
            },
            {text: item.total_unidades, options: {color: '333333', align: 'center', bold: false}},
            // {text: item.vendas, options: {color: '333333', align: 'center', bold: false}},
            // {text: item.estoque, options: {color: '333333', align: 'center', bold: false}},
          ])
        }
      })
      const slideconfigTable03 = {
        slide: slideT,
        tableData: tableData03,
        config: {
          x: 0.5,
          y: 4.4,
          w: 6,
          margin: 3,
          fontSize: 10,
          fill: {color: 'ffffff'},
          border: {pt: 1, color: 'd0d0d0'},
        },
      }

      slide.addTable(slideconfigTable03)

      //Ticket Médio em Estoque - R$
      slide.addText(
        'Ticket Médio em Estoque - R$',
        {
          x: 7.0,
          y: 4,
          w: 6.0,
          align: 'left',
          fontSize: 24,
          textTransform: 'upper',
          color: '333',
          fontFace: 'Arial',
        },
        slideT
      )

      let tableData04 = []
      tableData04.push([
        {text: 'Dormitórios', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Mínimo', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Mediana', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Máximo', options: {color: '333333', align: 'center', bold: true}},
        // {text: 'Total Unidades', options: {color: '333333', align: 'center', bold: true}},
        // {text: 'Vendidas', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Estoque', options: {color: '333333', align: 'center', bold: true}},
      ])
      // eslint-disable-next-line array-callback-return
      cacheResult.performanceResumoMercado.ticketMedioEstoque.tableData.map((item) => {
        if (!Array.isArray(item)) {
          tableData04.push([
            {text: item.dormitorios, options: {color: '333333', align: 'center'}},
            {
              text: formatNumber(Math.round(item.min), 'currency'),
              options: {color: '333333', align: 'center', bold: false},
            },
            {
              text: formatNumber(Math.round(item.mediana), 'currency'),
              options: {color: '333333', align: 'center', bold: false},
            },
            {
              text: formatNumber(Math.round(item.max), 'currency'),
              options: {color: '333333', align: 'center', bold: false},
            },
            // {text: item.total_unidades, options: {color: '333333', align: 'center', bold: false}},
            // {text: item.vendas, options: {color: '333333', align: 'center', bold: false}},
            {text: item.estoque, options: {color: '333333', align: 'center', bold: false}},
          ])
        }
      })

      const slideconfigTable04 = {
        slide: slideT,
        tableData: tableData04,
        config: {
          x: 7.0,
          y: 4.4,
          w: 6.0,

          margin: 3,
          fontSize: 10,
          fill: {color: 'ffffff'},
          border: {pt: 1, color: 'd0d0d0'},
        },
      }

      slide.addTable(slideconfigTable04)
    })

    //SLIDE -   Performance -   1
    slide.addSlide('Performance - Resumo Mercado ', (slideT) => {
      //COL1 Preço médio estoque

      // const slideconfigTable2 = SlideResumoMercado(data, slideT)

      let chartDataPrecoMedio = []
      let chartDataPrecoMedioLabels = []
      let chartDataPrecoMedioValues = []
      // eslint-disable-next-line array-callback-return
      cacheResult.performanceResumoMercado.ticketMedioEstoque.chartData.map((item) => {
        chartDataPrecoMedioLabels.push(item.x)
        chartDataPrecoMedioValues.push(item.y[2])
      })

      chartDataPrecoMedio.push({
        name: 'Preço Médio ',
        labels: chartDataPrecoMedioLabels,
        values: chartDataPrecoMedioValues,
      })

      const slideconfig1 = {
        slide: slideT,
        type: 'bar',
        charData: chartDataPrecoMedio,
        config: {
          x: 0.5,
          y: 1.4,
          w: 6.0,
          h: 3,
          chartArea: {fill: {color: 'ffffff'}},
          plotArea: {fill: {color: 'FFFFFF'}},
          catAxisLineShow: false,
          valAxisLineShow: false,
          barDir: 'col',
          title: 'Ticket médio por dormitório',
          // catAxisLineStyle:'dashad',
          valAxisHidden: false,
          valGridLine: {
            size: 1,
            style: 'dash',
            color: 'e4e4e4',
          },
          //showPercent:true,
          // barGapWidthPct: 25,
          chartColors: ['a7a7a7'],

          // chartColorsOpacity: 50,
          valAxisMinVal: 0,
          lineSize: 0,
          // valAxisMaxVal: 100,

          catAxisLabelColor: '333333',
          catAxisLabelFontFace: 'Arial',
          catAxisLabelFontSize: 11,
          catAxisLabelFrequency: 1,
          catAxisOrientation: 'minMax',

          // dataBorder: {pt: 1, color: '525252'},
          // dataLabelColor: '696969',
          dataLabelFontFace: 'Arial',
          dataLabelFontSize: 10,
          dataLabelPosition: 'outEnd',
          showValue: true,

          // valAxisHidden: true,
          catAxisTitle: 'Dormitórios',
          showCatAxisTitle: true,

          showLegend: true,
          showTitle: true,
        },
      }
      slide.addChartSingle(slideconfig1)

      let tableData = []
      tableData.push([
        {text: 'Dormitórios', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Mínimo', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Mediana', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Máximo', options: {color: '333333', align: 'center', bold: true}},
        // {text: 'Total Unidades', options: {color: '333333', align: 'center', bold: true}},
        // {text: 'Vendidas', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Estoque', options: {color: '333333', align: 'center', bold: true}},
      ])
      // eslint-disable-next-line array-callback-return
      cacheResult.performanceResumoMercado.ticketMedioEstoque.tableData.map((item) => {
        if (!Array.isArray(item)) {
          tableData.push([
            {text: item.dormitorios, options: {color: '333333', align: 'center'}},
            {
              text: formatNumber(Math.round(item.min), 'currency'),
              options: {color: '333333', align: 'center', bold: false},
            },
            {
              text: formatNumber(Math.round(item.mediana), 'currency'),
              options: {color: '333333', align: 'center', bold: false},
            },
            {
              text: formatNumber(Math.round(item.max), 'currency'),
              options: {color: '333333', align: 'center', bold: false},
            },
            // {text: item.total_unidades, options: {color: '333333', align: 'center', bold: false}},
            // {text: item.vendas, options: {color: '333333', align: 'center', bold: false}},
            {text: item.estoque, options: {color: '333333', align: 'center', bold: false}},
          ])
        }
      })

      const slideconfigTable1 = {
        slide: slideT,
        tableData: tableData,
        config: {
          x: 0.3,
          y: 4.4,
          w: 6.5,
          margin: 3,
          fontSize: 10,
          fill: {color: 'ffffff'},
          border: {pt: 1, color: 'd0d0d0'},
        },
      }

      slide.addTable(slideconfigTable1)

      let chartDataVsoPrograma = []
      // eslint-disable-next-line array-callback-return
      cacheResult.performanceResumoMercado.vsoPrograma.chartData.map((item) => {
        chartDataVsoPrograma.push({
          name: item.name,
          labels: item.data.map((dataItem, index) => dataItem.x),
          values: item.data.map((dataItem, index) => dataItem.y),
        })
      })
      //COL2 VSO Programa
      const slideconfig = {
        slide: slideT,
        type: 'bar',
        charData: chartDataVsoPrograma,
        config: {
          x: 7.0,
          y: 1.4,
          w: 6.0,
          h: 3,
          chartArea: {fill: {color: 'ffffff'}},
          plotArea: {fill: {color: 'FFFFFF'}},
          catAxisLineShow: false,
          valAxisLineShow: false,
          barDir: 'col',
          title: 'VSO Por Programa',
          // catAxisLineStyle:'dashad',
          valAxisHidden: false,
          valGridLine: {
            size: 1,
            style: 'dash',
            color: 'e4e4e4',
          },
          //showPercent:true,
          // barGapWidthPct: 25,
          chartColors: ['#a7a7a7', '#525252'],

          // chartColorsOpacity: 50,
          valAxisMinVal: 0,
          lineSize: 0,
          valAxisMaxVal: 100,

          catAxisLabelColor: '333333',
          catAxisLabelFontFace: 'Arial',
          catAxisLabelFontSize: 11,
          catAxisLabelFrequency: 1,
          catAxisOrientation: 'minMax',

          // dataBorder: {pt: 1, color: '525252'},
          // dataLabelColor: '696969',
          dataLabelFontFace: 'Arial',
          dataLabelFontSize: 10,
          dataLabelPosition: 'outEnd',
          showValue: true,

          // valAxisHidden: true,
          catAxisTitle: 'Dormitórios',
          showCatAxisTitle: true,

          showLegend: true,
          showTitle: true,
        },
      }
      slide.addChartSingle(slideconfig)

      let tableDataVSO = []
      tableDataVSO.push([
        {text: 'Dormitórios', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Total Unidades', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Estoque', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Vendidas', options: {color: '333333', align: 'center', bold: true}},
      ])
      // eslint-disable-next-line array-callback-return
      cacheResult.performanceResumoMercado.vsoPrograma.tableData.map((item) => {
        if (!Array.isArray(item)) {
          tableDataVSO.push([
            {text: item.domitorios, options: {color: '333333', align: 'center', bold: false}},
            {text: item.total_unidades, options: {color: '333333', align: 'center', bold: false}},
            {text: item.estoque, options: {color: '333333', align: 'center', bold: false}},
            {text: item.vendidas, options: {color: '333333', align: 'center', bold: false}},
          ])
        }
      })
      const slideconfigTable = {
        slide: slideT,
        tableData: tableDataVSO,
        config: {
          x: 7.0,
          y: 4.4,
          w: 6.0,
          margin: 3,
          fontSize: 10,
          fill: {color: 'ffffff'},
          border: {pt: 1, color: 'd0d0d0'},
        },
      }

      slide.addTable(slideconfigTable)
    })
    // SlidePerformanceResumoMercado(slide, cacheResult)

    //SLIDE -   Performance - Resumo Mercado 2
    slide.addSlide('Performance - Resumo Mercado', (slideT) => {
      //COL1 - Faixa Metragem

      let chartDataVSOFaixaMetragem = []
      // eslint-disable-next-line array-callback-return
      cacheResult.performanceResumoMercado.faixaMetragem.chartData.map((item) => {
        chartDataVSOFaixaMetragem.push({
          name: item.name,
          labels: item.data.map((dataItem, index) => dataItem.x),
          values: item.data.map((dataItem, index) => dataItem.y),
        })
      })

      const slideconfig1 = {
        slide: slideT,
        type: 'bar',
        charData: chartDataVSOFaixaMetragem,
        config: {
          x: 0.5,
          y: 1.4,
          w: 6.0,
          h: 3,
          chartArea: {fill: {color: 'ffffff'}},
          plotArea: {fill: {color: 'FFFFFF'}},
          catAxisLineShow: false,
          valAxisLineShow: false,
          barDir: 'col',
          title: 'VSO por Faixa de Metragem',
          // catAxisLineStyle:'dashad',
          valAxisHidden: false,
          valGridLine: {
            size: 1,
            style: 'dash',
            color: 'e4e4e4',
          },
          //showPercent:true,
          // barGapWidthPct: 25,
          chartColors: ['#a7a7a7', '#525252'],

          // chartColorsOpacity: 50,
          valAxisMinVal: 0,
          lineSize: 0,
          valAxisMaxVal: 100,

          catAxisLabelColor: '333333',
          catAxisLabelFontFace: 'Arial',
          catAxisLabelFontSize: 11,
          catAxisLabelFrequency: 1,
          catAxisOrientation: 'minMax',

          // dataBorder: {pt: 1, color: '525252'},
          // dataLabelColor: '696969',
          dataLabelFontFace: 'Arial',
          dataLabelFontSize: 10,
          dataLabelPosition: 'outEnd',
          showValue: true,

          // valAxisHidden: true,
          catAxisTitle: 'Dormitórios',
          showCatAxisTitle: true,

          showLegend: true,
          showTitle: true,
        },
      }
      slide.addChartSingle(slideconfig1)

      let tableData = []
      tableData.push([
        {text: 'Metragem', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Total Unidades', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Estoque', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Vendidas', options: {color: '333333', align: 'center', bold: true}},
      ])
      // eslint-disable-next-line array-callback-return
      cacheResult.performanceResumoMercado.faixaMetragem.tableData.map((item) => {
        if (!Array.isArray(item)) {
          tableData.push([
            {text: item.metragem, options: {color: '333333', align: 'center', bold: false}},
            {text: item.total_unidades, options: {color: '333333', align: 'center', bold: false}},
            {text: item.estoque, options: {color: '333333', align: 'center', bold: false}},
            {text: item.vendidas, options: {color: '333333', align: 'center', bold: false}},
          ])
        }
      })

      const slideconfigTable1 = {
        slide: slideT,
        tableData: tableData,
        config: {
          x: 0.5,
          y: 4.4,
          w: 6.0,
          margin: 3,
          fontSize: 10,
          fill: {color: 'ffffff'},
          border: {pt: 1, color: 'd0d0d0'},
        },
      }

      slide.addTable(slideconfigTable1)

      //COL2 Faixa Preço
      let chartDataVSOFaixaPreco = []
      // eslint-disable-next-line array-callback-return
      cacheResult.performanceResumoMercado.faixaTicket.chartData.map((item) => {
        chartDataVSOFaixaPreco.push({
          name: item.name,
          labels: item.data.map((dataItem, index) => dataItem.x),
          values: item.data.map((dataItem, index) => dataItem.y),
        })
      })
      const slideconfig = {
        slide: slideT,
        type: 'bar',
        charData: chartDataVSOFaixaPreco,
        config: {
          x: 7.0,
          y: 1.4,
          w: 6.0,
          h: 3,
          chartArea: {fill: {color: 'ffffff'}},
          plotArea: {fill: {color: 'FFFFFF'}},
          catAxisLineShow: false,
          valAxisLineShow: false,
          barDir: 'col',
          title: 'VSO por Faixa de Preço',
          // catAxisLineStyle:'dashad',
          valAxisHidden: false,
          valGridLine: {
            size: 1,
            style: 'dash',
            color: 'e4e4e4',
          },
          //showPercent:true,
          // barGapWidthPct: 25,
          chartColors: ['#a7a7a7', '#525252'],

          // chartColorsOpacity: 50,
          valAxisMinVal: 0,
          lineSize: 0,
          valAxisMaxVal: 100,

          catAxisLabelColor: '333333',
          catAxisLabelFontFace: 'Arial',
          catAxisLabelFontSize: 11,
          catAxisLabelFrequency: 1,
          catAxisOrientation: 'minMax',

          // dataBorder: {pt: 1, color: '525252'},
          // dataLabelColor: '696969',
          dataLabelFontFace: 'Arial',
          dataLabelFontSize: 10,
          dataLabelPosition: 'outEnd',
          showValue: true,

          // valAxisHidden: true,
          catAxisTitle: 'Dormitórios',
          showCatAxisTitle: true,

          showLegend: true,
          showTitle: true,
        },
      }
      slide.addChartSingle(slideconfig)

      let tableDataPreco = []
      tableDataPreco.push([
        {text: 'Preço (R$)', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Total Unidades', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Estoque', options: {color: '333333', align: 'center', bold: true}},
        {text: 'Vendidas', options: {color: '333333', align: 'center', bold: true}},
      ])
      // eslint-disable-next-line array-callback-return
      cacheResult.performanceResumoMercado.faixaTicket.tableData.map((item) => {
        if (!Array.isArray(item)) {
          tableDataPreco.push([
            {text: item.preco, options: {color: '333333', align: 'center', bold: false}},
            {text: item.total_unidades, options: {color: '333333', align: 'center', bold: false}},
            {text: item.estoque, options: {color: '333333', align: 'center', bold: false}},
            {text: item.vendidas, options: {color: '333333', align: 'center', bold: false}},
          ])
        }
      })

      const slideconfigTable = {
        slide: slideT,
        tableData: tableDataPreco,
        config: {
          x: 7.0,
          y: 4.4,
          w: 6.0,
          margin: 3,
          fontSize: 10,
          fill: {color: 'ffffff'},
          border: {pt: 1, color: 'd0d0d0'},
        },
      }

      slide.addTable(slideconfigTable)
    })

    //SLIDE -   Performance - Resumo Mercado 2
    slide.addSlide('Performance - Resumo Mercado', (slideT) => {
      slide.addText(
        'Média do Ticket por Dorm-Vaga',
        {
          x: 0.5,
          y: start,
          w: '100%',
          h: 0.6,
          align: 'left',
          fontSize: 24,
          textTransform: 'upper',
          color: '333',
          fontFace: 'Arial',
        },
        slideT
      )

      const input = cacheResult.performanceResumoMercado.mediaTickeDormVaga.chartData

      // Gerar arrDataLabels
      const arrDataLabels = [
        input.map((item) => item.x),
        input
          .map((item) => `${item.vagas} Dorm`)
          .map((label, i, arr) => (i === 0 || label !== arr[i - 1] ? label : '')),
      ]

      let obj = {
        name: `Dormitórios`,
        labels: arrDataLabels,
        values: input.map((item) => Math.round(item.y)),
      }

      const slideconfigTable = {
        slide: slideT,
        charData: [obj],
        type: 'bar',
        config: {
          x: 0.5,
          y: 2,
          w: 11,
          h: 5,

          catAxisMultiLevelLabels: true,
          chartColors: ['a7a7a7', 'C0504D'],

          // barDir: 'bar',
          // barDir: 'col',
          // catAxisMultiLevelLabels: true,
          // barGapWidthPct: 0,

          // dataLabelFontSize: 10,
          // dataLabelFormatCode: '#,##0,K',
          showValue: true,
          // chartColors: ['#99999', '#f0f0f0', '#c02525', '#3225c0', '#54c025', '#c0258c'],
          // catAxisLabelFontSize: 10,
          // valAxisMaxVal: 2000000,
        },
      }
      // slideT.slide.addChart(slideT, arrDataRegions)
      slide.addChartSingle(slideconfigTable)
    })

    //SLIDE -   Performance - Resumo Mercado 2
    slide.addSlide('Performance - Resumo Mercado', (slideT) => {
      slide.addText(
        'Média do Preço/m² por Dorm-Vaga',
        {
          x: 0.5,
          y: start,
          w: '100%',
          h: 0.6,
          align: 'left',
          fontSize: 24,
          textTransform: 'upper',
          color: '333',
          fontFace: 'Arial',
        },
        slideT
      )

      const input = cacheResult.performanceResumoMercado.mediaM2DormVaga.chartData

      // Gerar arrDataLabels
      const arrDataLabels = [
        input.map((item) => item.x),
        input
          .map((item) => `${item.vagas} Dorm`)
          .map((label, i, arr) => (i === 0 || label !== arr[i - 1] ? label : '')),
      ]

      let obj = {
        name: `Dormitórios`,
        labels: arrDataLabels,
        values: input.map((item) => Math.round(item.y)),
      }

      const slideconfigTable = {
        slide: slideT,
        charData: [obj],
        type: 'bar',
        config: {
          x: 0.5,
          y: 2,
          w: 11,
          h: 5,

          catAxisMultiLevelLabels: true,
          chartColors: ['a7a7a7', 'C0504D'],

          // barDir: 'bar',
          // barDir: 'col',
          // catAxisMultiLevelLabels: true,
          // barGapWidthPct: 0,

          // dataLabelFontSize: 10,
          // dataLabelFormatCode: '#,##0,K',
          showValue: true,
          // chartColors: ['#99999', '#f0f0f0', '#c02525', '#3225c0', '#54c025', '#c0258c'],
          // catAxisLabelFontSize: 10,
          // valAxisMaxVal: 2000000,
        },
      }
      // slideT.slide.addChart(slideT, arrDataRegions)
      slide.addChartSingle(slideconfigTable)
    })

    //SLIDE -   Performance - Resumo Mercado 2
    slide.addSlide('Performance - Resumo Mercado', (slideT) => {
      slide.addText(
        'Ofertas total por Dorm-Vaga (Número de unidades)',
        {
          x: 0.5,
          y: start,
          w: '100%',
          h: 0.6,
          align: 'left',
          fontSize: 24,
          textTransform: 'upper',
          color: '333',
          fontFace: 'Arial',
        },
        slideT
      )

      const input = cacheResult.performanceResumoMercado.ofertasTotalPorDorm.chartData

      // Gerar arrDataLabels
      const arrDataLabels = [
        input.map((item) => item.x),
        input
          .map((item) => `${item.vagas} Dorm`)
          .map((label, i, arr) => (i === 0 || label !== arr[i - 1] ? label : '')),
      ]

      let obj = {
        name: `Dormitórios`,
        labels: arrDataLabels,
        values: input.map((item) => Math.round(item.y)),
      }

      const slideconfigTable = {
        slide: slideT,
        charData: [obj],
        type: 'bar',
        config: {
          x: 0.5,
          y: 2,
          w: 11,
          h: 5,

          catAxisMultiLevelLabels: true,
          chartColors: ['a7a7a7', 'C0504D'],

          // barDir: 'bar',
          // barDir: 'col',
          // catAxisMultiLevelLabels: true,
          // barGapWidthPct: 0,

          // dataLabelFontSize: 10,
          // dataLabelFormatCode: '#,##0,K',
          showValue: true,
          // chartColors: ['#99999', '#f0f0f0', '#c02525', '#3225c0', '#54c025', '#c0258c'],
          // catAxisLabelFontSize: 10,
          // valAxisMaxVal: 2000000,
        },
      }
      // slideT.slide.addChart(slideT, arrDataRegions)
      slide.addChartSingle(slideconfigTable)
    })

    //SLIDE -   Performance - Resumo Mercado 2
    slide.addSlide('Comite Terrenos', (slideT) => {
      const accentColor = 'C2185B'
      const headerColor = 'a7a7a7'
      const borderColor = 'C2185B'

      slide.addText(
        'COMITE TERRENOS',
        {
          x: 0.5,
          y: start,
          w: '100%',
          h: 0.6,
          align: 'left',
          fontSize: 24,
          textTransform: 'upper',
          // color: accentColor,
          fontFace: 'Arial',
        },
        slideT
      )
      // slide.addText(
      //   'CONCORRENTES - ANÁLISE MERCADOLOGICA - MCMV - 2020 A 2025',
      //   {
      //     x: 0.5,
      //     y: start + 0.6,
      //     w: '100%',
      //     h: 0.4,
      //     align: 'left',
      //     fontSize: 10,
      //     color: accentColor,
      //     fontFace: 'Arial',
      //   },
      //   slideT
      // )

      if (mapImage.map1) {
        slideT.addImage({data: mapImage.map1, x: 0.6, y: 2.1, w: 6.5, h: 4.2})
      } else {
        slide.addText(
          'Mapa',
          {
            x: 0.5,
            y: 2.1,
            w: 6.8,
            h: 4.2,
            align: 'center',
            fontSize: 14,
            color: '666666',
            fontFace: 'Arial',
            fill: {color: 'F2F2F2'},
            border: {pt: 1, color: borderColor},
          },
          slideT
        )
      }

      const produtos = formatNumber(cacheResult.performance.totalProdutosLancados || 0, 'inteiro')
      const unidades = formatNumber(cacheResult.performance.unidadesLancadas || 0, 'inteiro')
      const estoque = formatNumber(cacheResult.performance.estoque || 0, 'inteiro')
      const precoMedioM2 = cacheResult.performance.precoMedioM2Estoque
        ? formatNumber(cacheResult.performance.precoMedioM2Estoque, 'inteiro')
        : '-'

      const addSmallBox = (title: string, value: string, x: number) => {
        slide.addText(
          title,
          {
            x,
            y: 2.1,
            w: 1.7,
            h: 0.35,
            align: 'center',
            fontSize: 11,
            color: '333',
            fontFace: 'Arial',
            fill: {color: headerColor},
          },
          slideT
        )
        slide.addText(
          value,
          {
            x,
            y: 2.45,
            w: 1.7,
            h: 0.55,
            align: 'center',
            fontSize: 18,
            color: '333333',
            fontFace: 'Arial',
            border: {pt: 1, color: borderColor},
          },
          slideT
        )
      }

      addSmallBox('PRODUTOS', produtos, 7.6)
      addSmallBox('UNIDADES', unidades, 9.45)
      addSmallBox('ESTOQUE', estoque, 11.3)

      slide.addText(
        'MESES ABSORÇÃO',
        {
          x: 7.6,
          y: 3.25,
          w: 5.4,
          h: 0.35,
          align: 'center',
          fontSize: 11,
          color: '333',
          fontFace: 'Arial',
          fill: {color: headerColor},
        },
        slideT
      )

      const absorcaoTipologias = cacheResult.absorcaoTipologias || []
      console.log('absorcaoTipologias')
      console.log(absorcaoTipologias)
      const absorcaoRows = absorcaoTipologias.filter(
        (row) => row.mesesAbsorcao !== '-' && !isNaN(row.mesesAbsorcao)
      )
      const absorcaoTableData = [
        [
          {text: 'Tipologia', options: {color: '333333', align: 'center', bold: true}},
          {text: 'Estoque', options: {color: '333333', align: 'center', bold: true}},
          {text: 'Venda Mensal', options: {color: '333333', align: 'center', bold: true}},
          {text: 'Absorcao (meses)', options: {color: '333333', align: 'center', bold: true}},
        ],
      ]

      if (absorcaoRows.length === 0) {
        absorcaoTableData.push([
          {text: '-', options: {color: '333333', align: 'center', bold: false}},
          {text: '-', options: {color: '333333', align: 'center', bold: false}},
          {text: '-', options: {color: '333333', align: 'center', bold: false}},
          {text: '-', options: {color: '333333', align: 'center', bold: false}},
        ])
      } else {
        absorcaoRows.forEach((row) => {
          absorcaoTableData.push([
            {text: `${row.tipologia}D`, options: {align: 'center', color: '333', bold: false}},
            {
              text: String(row.estoque ?? '-'),
              options: {align: 'center', color: '333', bold: false},
            },
            {
              text: String(row.vendaMensal ?? '-'),
              options: {align: 'center', color: '333', bold: false},
            },
            {
              text: String(row.mesesAbsorcao ?? '-'),
              options: {align: 'center', color: '333', bold: false},
            },
          ])
        })
      }

      slideT.addTable(absorcaoTableData, {
        x: 7.6,
        y: 3.6,
        w: 5.4,
        fontSize: 9,
        color: '333333',
        border: {type: 'solid', pt: 1, color: 'd0d0d0'},
        colW: [1.1, 1.1, 1.6, 1.6],
      })

      const precoMedioLanc = cacheResult.performanceResumoMercado.precoMedioLancamentoM2
      let textoPrecoMedioLanc = ''
      precoMedioLanc.tableData.map((item) => {
        if (item?.mediana > 0) {
          textoPrecoMedioLanc =
            textoPrecoMedioLanc +
            item.dormitorios +
            formatNumber(Math.round(item.mediana), 'currency') +
            '\n'
        }
      })

      slide.addText(
        'PRECO MEDIO M2',
        {
          x: 7.6,
          y: 5,
          w: 2.6,
          h: 0.35,
          align: 'center',
          fontSize: 11,
          color: '333',
          fontFace: 'Arial',
          fill: {color: headerColor},
        },
        slideT
      )
      slide.addText(
        `${textoPrecoMedioLanc}`,
        {
          x: 7.6,
          y: 5.55,
          w: 2.6,
          h: 0.65,
          align: 'center',
          fontSize: 12,
          color: '333333',
          fontFace: 'Arial',
          border: {pt: 1, color: borderColor},
        },
        slideT
      )

      const ticketMedioLanc = cacheResult.performanceResumoMercado.ticketMedioLancamentoEstoque
      let textoticketMedioLanc = ''
      ticketMedioLanc.tableData.map((item) => {
        if (item?.mediana > 0) {
          textoticketMedioLanc =
            textoticketMedioLanc +
            item.dormitorios +
            formatNumber(Math.round(item.mediana), 'currency') +
            '\n'
        }
      })
      slide.addText(
        'TICKET MEDIO M2',
        {
          x: 10.4,
          y: 5,
          w: 2.6,
          h: 0.35,
          align: 'center',
          fontSize: 11,
          color: '333',
          fontFace: 'Arial',
          fill: {color: headerColor},
        },
        slideT
      )

      slide.addText(
        `${textoticketMedioLanc}`,

        {
          x: 10.4,
          y: 5.55,
          w: 2.6,
          h: 0.65,
          align: 'center',
          fontSize: 12,
          color: '333333',
          fontFace: 'Arial',
          border: {pt: 1, color: borderColor},
        },
        slideT
      )
    })
    slide.addSlide('Estudo de Demanda', (slideT) => {
      slide.addText(
        'Estudo de Demanda',
        {
          x: 0.5,
          y: start,
          w: '100%',
          h: 0.6,
          align: 'left',
          fontSize: 24,
          textTransform: 'upper',
          color: '333',
          fontFace: 'Arial',
        },
        slideT
      )
      const legendaTable = [
        [{text: '', options: {fill: {color: '00B050'}}}, 'VSO Acima da curva'],
        [{text: '', options: {fill: {color: 'FFE600'}}}, 'VSO Media da curva'],
        [{text: '', options: {fill: {color: 'FF0000'}}}, 'VSO Abaixo da curva'],
      ]
      slideT.addTable(legendaTable, {
        x: 9.2,
        y: start - 0.1,
        w: 3.8,
        fontSize: 10,
        color: '333333',
        border: {pt: 0, color: 'FFFFFF'},
        colW: [0.2, 3.6],
      })
      const estudoDemandaRows = cacheResult.estudoDemanda || []

      if (estudoDemandaRows.length === 0) {
        slide.addText(
          'Sem dados para Estudo de Demanda',
          {
            x: 0.5,
            y: start + 0.9,
            w: '100%',
            h: 0.6,
            align: 'left',
            fontSize: 14,
            color: '333',
            fontFace: 'Arial',
          },
          slideT
        )
        return
      }

      const tableData = []
      const normalizeColor = (color: string) => {
        if (!color) {
          return ''
        }
        const lower = color.toLowerCase()
        if (lower === 'red') {
          return 'FF0000'
        }
        if (lower === 'green') {
          return '00B050'
        }
        if (lower === 'yellow') {
          return 'FFE600'
        }
        if (lower.startsWith('#')) {
          return lower.slice(1).toUpperCase()
        }
        return color.toUpperCase()
      }
      const getColoredCell = (value, color: string) => {
        const normalizedColor = normalizeColor(color)
        if (!normalizedColor) {
          return {
            text: value,
            options: {align: 'center'},
          }
        }
        const textColor = normalizedColor === 'FFE600' ? '000000' : 'FFFFFF'
        return {
          text: value,
          options: {fill: {color: normalizedColor}, color: textColor, align: 'center'},
        }
      }
      tableData.push([
        'Renda Media Domiciliar',
        'Faixa de Preco Imóvel (R$)',
        'Domicílios (2026)',
        'Estimativa Novos Domicílios (Próximos 5 anos)',
        'Unidades Lancadas',
        'Estoque X Demanda',
        'Estoque X Absorção',
        'Venda Média Mensal',
        'Meses Absorção',
        '1 Dorm (VSO/Estoque)',
        '2 Dorm (VSO/Estoque)',
        '3 Dorm (VSO/Estoque)',
        '4+ Dorm (VSO/Estoque)',
        'Landbank (UH)',
        'Meses Demanda',
      ])
      const getDormCell = (cell?: {value?: number | string; color?: string; estoque?: number}) => {
        const hasValue =
          cell && cell.value !== undefined && cell.value !== null && cell.value !== ''
        const valueText = hasValue ? String(cell.value) : '-'
        const estoqueNumber = Number(cell?.estoque)
        const hasEstoque = Number.isFinite(estoqueNumber) && estoqueNumber >= 0
        const fullText = hasEstoque ? `${valueText}/${estoqueNumber}` : valueText

        if (hasValue && cell?.color) {
          return getColoredCell(fullText, cell.color)
        }

        return {text: fullText, options: {align: 'center'}}
      }

      estudoDemandaRows.forEach((row) => {
        tableData.push([
          row.rendaMediaDomiciliar,
          row.faixaPrecoImovel,
          {text: row.domicilios || '-', options: {align: 'center'}},
          {text: row.estimativaNovosDomicilios || '-', options: {align: 'center'}},
          {text: row.unidadesLancadas || '-', options: {align: 'center'}},
          getColoredCell(row.estoque?.value ?? '', row.estoque?.color),
          getColoredCell(row.estoque_absorcao?.value ?? '-', row.estoque_absorcao?.color),
          {text: row.vendaMediaMensal ?? '-', options: {align: 'center'}},
          {text: row.mesesAbsorcao ?? '-', options: {align: 'center'}},
          getDormCell(row.dorm1),
          getDormCell(row.dorm2),
          getDormCell(row.dorm3),
          getDormCell(row.dorm4),
          {text: row.landbank ?? '-', options: {align: 'center'}},
          getColoredCell(row.mesesDemanda?.value ?? '-', row.mesesDemanda?.color),
        ])
      })

      slideT.addTable(tableData, {
        x: 0.5,
        y: start + 0.9,
        w: 12.3,
        colW: [1.8, 1.5, 0.75, 1, 0.9, 0.8, 0.8, 0.85, 0.8, 0.65, 0.65, 0.65, 0.65, 0.75, 0.75],
        fontSize: 9,
        color: '333333',
        border: {type: 'solid', pt: 1, color: 'd0d0d0'},
      })
    })
    //SLIDE -   Performance - Resumo Mercado 2
    // slide.addSlide('Performance - Resumo Mercado', (slideT) => {
    //   slide.addText(
    //     'Oferta total por Dorm-Vaga x Vendas',
    //     {
    //       x: 0.5,
    //       y: start,
    //       w: '100%',
    //       h: 0.6,
    //       align: 'left',
    //       fontSize: 24,
    //       textTransform: 'upper',
    //       color: '333',
    //       fontFace: 'Arial',
    //     },
    //     slideT
    //   )

    //   const input =
    //     cacheResult.performanceResumoMercado.ofertasTotalPorDormVagasxVendas.chartData[0].data
    //   const input2 =
    //     cacheResult.performanceResumoMercado.ofertasTotalPorDormVagasxVendas.chartData[1].data
    //   // console.log('input')
    //   // console.log(input)
    //   // console.log('input2')
    //   // console.log(input2)
    //   // Gerar arrDataLabels
    //   const arrDataLabels = [
    //     input.map((item) => item.x),
    //     input
    //       .map((item) => `${item.dormitorios}`)
    //       .map((label, i, arr) => (i === 0 || label !== arr[i - 1] ? label : '')),
    //   ]

    //   let obj = [
    //     {
    //       name: `Vendas`,
    //       labels: arrDataLabels,
    //       values: input.map((item) => Math.round(item.y)),
    //     },
    //     {
    //       name: `Total Unidades`,
    //       labels: arrDataLabels,
    //       values: input2.map((item) => Math.round(item.y)),
    //     },
    //   ]

    //   // console.log('arrDataLabels')
    //   // console.log(arrDataLabels)

    //   // console.log('obj')
    //   // console.log(obj)
    //   const slideconfigTable = {
    //     slide: slideT,
    //     charData: obj,
    //     type: 'bar',
    //     config: {
    //       x: 0.5,
    //       y: 2,
    //       w: 11,
    //       h: 5,
    //       barDir: 'col',
    //       catAxisMultiLevelLabels: true,
    //       chartColors: ['a7a7a7', 'C0504D'],
    //       dataLabelFormatCode: (value) => {
    //         return 'teste'
    //       },
    //       // barDir: 'bar',
    //       // barDir: 'col',
    //       // catAxisMultiLevelLabels: true,
    //       // barGapWidthPct: 0,

    //       // dataLabelFontSize: 10,
    //       // dataLabelFormatCode: '#,##0,K',
    //       showValue: true,
    //       // chartColors: ['#99999', '#f0f0f0', '#c02525', '#3225c0', '#54c025', '#c0258c'],
    //       // catAxisLabelFontSize: 10,
    //       // valAxisMaxVal: 2000000,
    //     },
    //   }
    //   // console.log(slideconfigTable)
    //   // slideT.slide.addChart(slideT, arrDataRegions)
    //   slide.addChartSingle(slideconfigTable)
    // })

    //SLIDE -   ANÁLISE Concorrentes
    // let vsoChart = vsoIdeal.map((item) => {
    //   return item.vso
    // })

    // let dataArrayDormi = Array(7).fill([], 0)
    // let dataArrayDormiLabels = Array(7).fill([], 0)
    // // eslint-disable-next-line array-callback-return
    // dataArrayDormi.map((val, index) => {
    //   dataArrayDormi[index] = [] //Array(vsoChart.length).fill(null, 0)
    //   dataArrayDormiLabels[index] =[] // Array(vsoChart.length).fill(null, 0)
    // })

    // console.log(vsoChart)
    // // eslint-disable-next-line array-callback-return
    // data.filter((item) => {
    //   // eslint-disable-next-line array-callback-return
    //   item.tipologias.filter((itemTipologia,index) => {
    //     if (itemTipologia.computed) {
    //       let indexVso = vsoIdeal.findIndex(
    //         (fase, index) => index === Number(item.fase_projeto_ideal)
    //       )
    //       dataArrayDormi[Number(itemTipologia.bedrooms)].push({y:itemTipologia.vendas_perc_tip,x:Number(item.fase_projeto)})
    //       dataArrayDormiLabels[Number(itemTipologia.bedrooms)].push(index)
    //     }
    //   })
    // })
    // console.log(dataArrayDormi)
    // console.log(dataArrayDormiLabels)
    // let vsoChartANÁLISEConcorrentesLabel = []
    // let vsoChartANÁLISEConcorrentes = []
    // vsoChartANÁLISEConcorrentesLabel = [
    //   0,
    //   3,
    //   6,
    //   8,
    //   11,
    //   14,
    //   17,
    //   19,
    //   22,
    //   25,
    //   28,
    //   31,
    //   33,
    //   36,
    //   39,
    //   42,
    //   44,
    //   47,
    //   50,
    //   53,
    //   56,
    //   58,
    //   61,
    //   64,
    //   67,
    //   69,
    //   72,
    //   75,
    //   78,
    //   81,
    //   83,
    //   86,
    //   89,
    //   92,
    //   94,
    //   97,
    //   100,
    // ]

    // vsoIdeal.map((item, index) => {
    //   vsoChartANÁLISEConcorrentes[index] = item.vso
    // })

    // dataArrayDormi.map((d, index) => {
    //   if (!isAllEmpty(d)) {

    //     console.log(d)

    //     // let fase = Math.round((Number(d.fase_projeto) * 36) / 100)
    //     // if (d.vso >= vsoIdeal[fase].vso) {
    //     //   return 'Acima'
    //     // }
    //     // fase = Math.round((Number(d.fase_projeto) * 36) / 100)
    //     // if (d.vso < vsoIdeal[fase].vso) {
    //     //   return 'Abaixo'
    //     // }

    //     console.log(dataArrayDormiLabels)
    //     console.log(dataArrayDormi)
    //     slide.addSlide(`Análise Concorrentes - ${index} Dormitório(s)`, (slideT) => {
    //       const slideconfig = {
    //         slide: slideT,
    //         charData: [
    //           {
    //             type: 'scatter',
    //             data: [
    //               {
    //                 name: 'VSO',
    //                 labels: dataArrayDormiLabels[index], //dataArrayDormiLabels[index],
    //                 values: dataArrayDormi[index],
    //               },
    //             ],
    //             options: {chartColors: ['FF0000']},
    //           },
    //           // {
    //           //   type: 'line',
    //           //   data: [
    //           //     {
    //           //       name: 'VSO Ideal',
    //           //       labels: vsoChartANÁLISEConcorrentesLabel,
    //           //       values: vsoChartANÁLISEConcorrentes,
    //           //     },
    //           //   ],
    //           //   options: {chartColors: ['333']},
    //           // },
    //         ],
    //         config: {
    //           x: 0.5,
    //           y: 2.0,
    //           w: '50%',
    //           h: 4,
    //           xAxisMimVal: 0,
    //           xAxisMaxVal: 100,
    //           yAxisMimVal: 0,
    //           yAxisMaxVal: 100,
    //           catAxisLabelColor: '494949',
    //           catAxisLabelFontFace: 'Arial',
    //           catAxisLabelFontSize: 10,
    //           catAxisOrientation: 'minMax',
    //           // showLabel: true,
    //           dataLabelPosition: 'b',
    //           //
    //           // showLegend: true,
    //           // dataLabelFormatScatter: 'custom',
    //           // legendPos: 'b',
    //           //
    //           showTitle: true,
    //           titleFontFace: 'Calibri Light',
    //           titleFontSize: 14,
    //           title: 'Vendas Real x Curva Ideal de Vendas',
    //         },
    //       }
    //       slide.addChart(slideconfig)

    //       let tableData = []
    //       tableData.push([
    //         {text: '', options: {color: '333333', align: 'center', bold: true}},
    //         {text: 'Acima da Curva', options: {color: '333333', align: 'center', bold: true}},
    //         {text: 'Abaixo da Curva', options: {color: '333333', align: 'center', bold: true}},
    //       ])
    //       // data.map((item,index) => {
    //       //   if (!Array.isArray(item)) {
    //       //     if (item.computed && !item.removed) {

    //       //     }
    //       //   }
    //       // })
    //       tableData.push([
    //         {text: 'Total unidades', options: {color: '333333', align: 'center'}},
    //         {text:formatNumber(Math.round(1270), 'inteiro'), options: {color: '333333', align: 'center', bold: false}},
    //         {text:formatNumber(Math.round(1283), 'inteiro'), options: {color: '333333', align: 'center', bold: false}},
    //       ])
    //       tableData.push([
    //         {text: 'Preço mediano', options: {color: '333333', align: 'center'}},
    //         {text:formatNumber(Math.round(1270), 'inteiro'), options: {color: '333333', align: 'center', bold: false}},
    //         {text:formatNumber(Math.round(1283), 'inteiro'), options: {color: '333333', align: 'center', bold: false}},
    //       ])
    //       tableData.push([
    //         {text: 'Ticket mediano', options: {color: '333333', align: 'center'}},
    //         {text:formatNumber(Math.round(1270), 'inteiro'), options: {color: '333333', align: 'center', bold: false}},
    //         {text:formatNumber(Math.round(1283), 'inteiro'), options: {color: '333333', align: 'center', bold: false}},
    //       ])
    //       tableData.push([
    //         {text: 'Área privativa mediana', options: {color: '333333', align: 'center'}},
    //         {text:formatNumber(Math.round(1270), 'inteiro'), options: {color: '333333', align: 'center', bold: false}},
    //         {text:formatNumber(Math.round(1283), 'inteiro'), options: {color: '333333', align: 'center', bold: false}},
    //       ])
    //       tableData.push([
    //         {text: 'Moda de produto com/sem vaga', options: {color: '333333', align: 'center'}},
    //         {text:formatNumber(Math.round(1270), 'inteiro'), options: {color: '333333', align: 'center', bold: false}},
    //         {text:formatNumber(Math.round(1283), 'inteiro'), options: {color: '333333', align: 'center', bold: false}},
    //       ])
    //       const slideconfigTable1 = {
    //         slide: slideT,
    //         tableData: tableData,
    //         config: {
    //           x: 7.8,
    //           y: 2.0,
    //           w: 5.2,
    //           margin: 3,
    //           fontSize: 10,
    //           fill: {color: 'ffffff'},
    //           border: {pt: 1, color: 'd0d0d0'},
    //         },
    //       }

    //       slide.addTable(slideconfigTable1)

    //     })

    //   }
    // })

    // SLIDE -   Mercado revenda
    // slide.addSlide('Mercado Revenda', (slideT) => {
    //   slide.addBox({
    //     slide: slideT,
    //     titulo: 'PREÇO MEDIANO M²',
    //     subtitulo: 'Valor do preço médio do m² ',
    //     valor: formatNumber(
    //       Math.round(cacheResult.performanceMercadoRevenda.precoMedianoM2),
    //       'currency'
    //     ),
    //     config: {
    //       x: 9.8,
    //       y: 1.4,
    //       w: 3.3,
    //       h: 1.3,
    //       margin: 15,
    //       fill: {color: 'ffffff'},
    //       borderColor: '333333',
    //       borderTopLeftRadius: 5,
    //       lineSpacingMultiple: 1.5,
    //     },
    //   })

    //   slide.addBox({
    //     slide: slideT,
    //     titulo: 'PREÇO Q1',
    //     subtitulo: 'Preço médiodo m² - Primeiro Quartil ',
    //     valor: formatNumber(
    //       Math.round(cacheResult.performanceMercadoRevenda.precoQ1m2),
    //       'currency'
    //     ),
    //     config: {
    //       x: 9.8,
    //       y: 2.6,
    //       w: 3.3,
    //       h: 1.3,
    //       margin: 15,
    //       fill: {color: 'ffffff'},
    //       borderColor: '333333',
    //       borderTopLeftRadius: 5,
    //       lineSpacingMultiple: 1.5,
    //     },
    //   })

    //   slide.addBox({
    //     slide: slideT,
    //     titulo: 'PREÇO Q3',
    //     subtitulo: 'Preço médiodo m² - Terceiro Quartil ',
    //     valor: formatNumber(
    //       Math.round(cacheResult.performanceMercadoRevenda.precoQ3m2),
    //       'currency'
    //     ),
    //     config: {
    //       x: 9.8,
    //       y: 3.9,
    //       w: 3.3,
    //       h: 1.3,
    //       margin: 15,
    //       fill: {color: 'ffffff'},
    //       borderColor: '333333',
    //       borderTopLeftRadius: 5,
    //       lineSpacingMultiple: 1.5,
    //     },
    //   })

    //   slide.addBox({
    //     slide: slideT,
    //     titulo: 'TOTAL DE AMOSTRAS',
    //     subtitulo: 'Total de amostras utilizadas',
    //     valor: formatNumber(
    //       Math.round(cacheResult.performanceMercadoRevenda.totalAmostras),
    //       'inteiro'
    //     ),
    //     config: {
    //       x: 9.8,
    //       y: 5.4,
    //       w: 3.3,
    //       h: 1.3,
    //       margin: 15,
    //       fill: {color: 'ffffff'},
    //       borderColor: '333333',
    //       borderTopLeftRadius: 5,
    //       lineSpacingMultiple: 1.5,
    //     },
    //   })

    //   slideT.addImage({data: mapImage.map3, x: 0.6, y: 1.4, w: 8, h: 5.5})
    //   slideT.addImage({data: legendaDistancia, x: 0.7, y: 6.2, w: 0.9, h: 0.6})
    //   // slideT.addImage({data: imageLegenda3, x: 6.3, y: 6.2, w: 2.8, h: 0.6})
    // })

    slide.salvar('Urbit - Inteligência de Mercado - ' + dadosProjetoSalvo.nome)

    // CloseLoaderInfoOverlay()

    setMapImage({
      map1: null,
      map2: null,
      map3: null,
      concorrencia: [],
    })
    setGenerateMap(false)
  }

  return (
    <>
      {!generateMap ? (
        <button
          className='btn btn-icon-gray-700 btn-text-gray-700 btn-secondary'
          style={{width: '100% !important'}}
          onClick={async () => {
            // LoaderInfoOverlay('Gerando estudo...')
            setGenerateMap(true)
          }}
        >
          <BiExport></BiExport> Gerar PPT
        </button>
      ) : (
        <></>
      )}
      {isMapExportReady ? (
        <button
          className='btn btn-icon-gray-700 btn-text-gray-700 btn-secondary'
          style={{width: '100% !important'}}
          onClick={async () => {
            // LoaderInfoOverlay('Gerando estudo...')
            await handleExport()
          }}
        >
          <BiDownload></BiDownload> Baixar Arquivo
        </button>
      ) : (
        <></>
      )}

      {generateMap && !isMapExportReady ? (
        <button
          className='btn btn-icon-gray-700 btn-text-gray-700 btn-secondary disabled'
          style={{width: '100% !important'}}
        >
          <BiLoader></BiLoader> Carregando...
        </button>
      ) : (
        <></>
      )}

      <div style={{position: 'fixed', width: '1000', height: '850', left: '-1000px', top: 0}}>
        <LegendaIsocronas setLegendaDistancia={setLegendaDistancia} />
      </div>
      {generateMap ? <Mapas data={data} setMapImageExport={setMapImage}></Mapas> : <></>}
    </>
  )
}
